<div class="icon-cont">
  <a class="social-icon" target="_blank" rel="noopener" href="{{componentData.url}}" role="button">
      <i class="sg-icon sg-icon-instagram"></i>
  </a>
</div>
